'use client'
import {
  Headline,
  Subheadline,
  Container,
  ContentWrapper,
  CTAContainer
} from '@/components/ui'
import { CTAButton } from '@/components/ui/cta-button'
import MediaContainer from '@/components/ui/MediaContainer'
import GradientContainer from '@/components/ui/GradientContainer'
import { useCTAUrl } from '@/lib/use-cta-url'
import { GradientVariant, HeadlineVariant } from '@/types/ui'
import { usePageSettings } from '@/components/contexts/PageSettingsContext'
interface DictateAndImproveProps {
  gradientVariant?: GradientVariant
  headlineVariant?: HeadlineVariant
  title?: string
  subtitle?: string
}

const DictateAndImprove = ({ 
  gradientVariant = '13', 
  headlineVariant,
  title = "Dictate and improve with AI.",
  subtitle = "Speak your thoughts, then let AI enhance them. Perfect for complex tasks, detailed descriptions, and professional communication."
}: DictateAndImproveProps) => {
  
  const { enableDictateAndImproveGoogleLogin, showGoogleLogoDictateAndImprove } = usePageSettings()
  const {href: ctaUrl, isCalendly} = useCTAUrl()
  return (
      <Container variant="section">
        <ContentWrapper gap="lg">
          <Headline variant={headlineVariant}>{title}</Headline>
          <Subheadline htmlContent={true}>
            {subtitle}
          </Subheadline>
          
          <GradientContainer gradientVariant={gradientVariant} variant="fullscreen">
            <MediaContainer 
              src="/images/sections/1758547129117dictate_and_improve.avif" 
              type="video"
              alt="Dictate and Improve Functions"
              className='md:max-w-[75%]'
            />
           
          </GradientContainer>
           
          {/* CTA Button */}
          <CTAContainer marginTop="sm">
            <CTAButton
              href={ctaUrl}
              variant="primary"
              size="lg"
              enableGoogleLogin={enableDictateAndImproveGoogleLogin && !isCalendly}
              showGoogleLogo={showGoogleLogoDictateAndImprove}
              external={ctaUrl.startsWith('http')}
            >
              Get Started
            </CTAButton>
          </CTAContainer>
        </ContentWrapper>
      </Container>
  )
}

export default DictateAndImprove 